import './App.css';
import React from 'react'
import { Route, Routes } from 'react-router-dom';

import Main from './components/mainPage/main'
import Home from './components/mainPage/home/home'
import Projects from './components/projects/projects';
import Contact from './components/contact/contact';
import About from './components/about/about';
import Experience from './components/experience/experience';

function App() {
    return (
        <Routes>
            <Route path='/' element={<Main />}>
                <Route index element={<Home />}/>
                <Route path='/experience' element={<Experience />}/>
                <Route path='/about' element={<About />}/>
                <Route path='/projects' element={<Projects />}/>
                <Route path='/contact' element={<Contact />}/>
            </Route>
        </Routes>
    );
}

export default App;
